// EDEN · Coach — the third tab: philosophy #3 made visible. A quiet hub, not a feature list:
// talk a plan through (the existing no-scores coach), find your Lead's English feedback
// (1-on-1 surfaces — the wall stays structural), and the after-lesson reflection (lands with
// the plan-form increment). Nothing here scores, ranks, or compares anyone with anyone.

import { t } from "../i18n";

export function renderCoach(app: HTMLElement): void {
  app.innerHTML = `
    <h1>${t("home.coach")}</h1>
    <a class="card coach-card" data-link href="/speak/new">
      <strong>🎙 ${t("coach.talk_title")}</strong>
      <p class="meta">${t("coach.talk_sub")}</p>
      <span class="linkbtn">${t("coach.talk_cta")} ›</span>
    </a>
    <a class="card coach-card" data-link href="/observations">
      <strong>${t("coach.feedback_title")}</strong>
      <p class="meta">${t("coach.feedback_sub")}</p>
    </a>
    <div class="card coach-card is-dim">
      <strong>${t("coach.reflect_title")}</strong>
      <p class="meta">${t("coach.reflect_sub")}</p>
    </div>`;
}
